import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Field } from 'formik'
import ReactMarkdown from 'react-markdown'
import { connect } from 'react-redux'
import { CaptchaValueFieldName, personCustomerType } from '../constants/GeneralConstants'


const Checkmark = styled.span`
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    border: 1px solid ${props => props.theme.colors.base};
    border-radius: 4px;

    &:after {
        content: "";
        position: absolute;
        display: none;
        left: 6px;
        top: 3px;
        width: 4px;
        height: 8px;
        border: solid white;
        border-width: 0 2px 2px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }
`

const Checkbox = styled(Field)`
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;

    &:checked ~ ${Checkmark}:after {
        display: block;
    }

    &:checked ~ ${Checkmark} {
        background-color: ${props => props.theme.colors.darkGreen};
      }
`

const SelectionLabel = styled.label`
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border-radius: 25px;
`

const SelectionWrapper = styled.div`
    flex: 100%;
    position:relative;
`

const Header = styled.h3`
    @media (max-width: ${props => props.theme.responsive.small}) {
        font-size: 16px;
    }
    flex: 100%;
    padding-bottom: 0.5em;
    font-weight: bold;
`

const CheckboxGroupWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 3em;
`

class CheckboxGroup extends React.Component {

    render() {
        const { data, customerType } = this.props
        const {
            selections,
            header,
            description,
            integrationObjectName,
            required
        } = data

        const isPerson = customerType === personCustomerType

        return (
            <>
                {integrationObjectName === CaptchaValueFieldName
                // captcha is also a checkbox, but it is rendered instead in FormContainer
                    ? null
                    : <CheckboxGroupWrapper
                        className={isPerson
                            ? 'checkboxGroupWrapper'
                            : ''
                        }
                    >
                        <Header>
                            {header} {required && required === true && '*'}
                        </Header>
                        {selections && selections.map((item, index) =>
                            <SelectionWrapper key={index}>
                                <SelectionLabel>
                                    <ReactMarkdown
                                        source={item.header || ''}
                                        renderers={{link: props => <a href={props.href} rel="noopener noreferrer" target="_blank">{props.children}</a>}}
                                    />
                                    <Checkbox
                                        id={item.mappingId}
                                        name={integrationObjectName}
                                        type="checkbox"
                                    />
                                    <Checkmark/>

                                </SelectionLabel>
                                {/*this.state.selectedValues.indexOf(index.toString()) > -1 && item.description &&
                                    <SelectionDescription>
                                    {Parser(item.description.childMarkdownRemark.html)}
                                    </SelectionDescription>
                                */}
                            </SelectionWrapper>
                        )}
                        {description &&
                            <ReactMarkdown
                                source={description.description || ''}
                                renderers={{link: props => <a href={props.href} rel="noopener noreferrer" target="_blank">{props.children}</a>}}
                            />
                        }
                    </CheckboxGroupWrapper>
                }
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        customerType: state.customerTypeReducer.customerType,
    }
}

CheckboxGroup.propTypes = {
    data: PropTypes.object,
    customerType: PropTypes.string,
}

export default connect(mapStateToProps)(CheckboxGroup)
